<script lang="ts">
  import Icon from './Icon.svelte'

  export let color: 'primary' | 'tertiary' | 'warning' | 'success' | 'error' =
    'warning'
  export let icon: string | undefined = undefined
</script>

<div class="alert {color}" role="alert">
  {#if icon}
    <Icon {icon} />
  {/if}
  <slot />
</div>

<style lang="scss">
  .alert {
    display: flex;
    align-items: center;
    gap: 0.5em;
    min-height: var(--input-height);
    padding: var(--input-padding);
    background: var(--color-warning);
    color: #000;
    --icon-color: #000;
    border: var(--input-border);
    border-radius: var(--input-border-radius);
    border: 1px solid var(--color-warning);
    font-size: 0.9375rem;
    margin-bottom: 1em;

    &.primary {
      background: var(--color-primary);
      border: 1px solid var(--color-primary);
    }

    &.tertiary {
      background: var(--color-tertiary);
      border: 1px solid var(--color-tertiary);
    }

    &.success {
      background: var(--color-success);
      border: 1px solid var(--color-success);
    }

    &.error {
      background: var(--color-error);
      border: 1px solid var(--color-error);
      color: #fff;
    }
  }
</style>
